import '../../../../styles/pages/warehouse/_return/index.scss';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import ReturnOrderPage from '../../Return/pages/ReturnOrderPage';
import ReturnImportPage from '../../Return/pages/ReturnImportPage';
import ReturnStockPage from '../../Return/pages/ReturnStockPage';
import { useActions } from '@root/core/hooks/useActions';
import { useEffect, useState } from 'react';
import {
  Comment,
  CommentGroup,
  CommentList,
  CommentSide,
  CommentStatus,
  CommentTabs,
  CommentType,
  CreateComment
} from '@core/components/CommentTabs/interface';
import commentService from '@core/components/CommentTabs/commentService';
import CommentTabsComponent from '@core/components/CommentTabs';
import returnDisposalService from '../../Return/Service/returnDisposal';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { ReturnDisposalDetailState } from '@root/state/reducers/return_disposal/returnDisposalReducer';
import ProgressForm from '@modules/Warehouse/Return/components/ProgressForm';
import RecipientForm from '@modules/Warehouse/Return/components/RecipientForm';
import RecipientReturnForm from '@modules/Warehouse/Delivery/components/RecepientReturnForm';
import ProgressReturnForm from '@modules/Warehouse/Delivery/components/ProgressReturnForm';
interface ParamType {
  id: string;
}
function ReturnDeliveryDetail() {
  const location = useLocation();
  const Breadcrumb = [
    {
      tittle: 'Return List',
      url: '/admin/returnDelivery'
    },
    {
      tittle: 'Detailed Return',
      url: ''
    }
  ];

  // handle api detail
  const { id } = useParams<ParamType>();

  const { handleReturnDisposalDetail } = useActions();
  const [commentList, setCommentList] = useState<CommentList>();
  const [canEdit, setCanEdit] = useState(false);
  const [commentAllId, setCommentAllId] = useState(0);
  const [tabs, setTabs] = useState<CommentTabs[]>([]);
  const { detailData, detailLoading } =
    useTypedSelector<ReturnDisposalDetailState>(
      (state) => state.returnDisposalDetailReducer
    );
  const [showReturnProcess, setShowReturnProcess] = useState(false);

  useEffect(() => {
    if (detailData?.data) {
      if (detailData?.data?.processType === 'return')
        if (
          detailData?.data?.status === 'Request' ||
          detailData?.data?.status === 'Inprogress'
        ) {
          setTabs([
            {
              title: 'Request modify',
              description: 'Reasons for modification from Warehouse :',
              type: CommentType.REQUEST_MODIFY,
              options: []
            },
            {
              title: 'Request delete',
              description: 'Reasons for modification from Warehouse :',
              type: CommentType.REQUEST_DELETE,
              options: []
            }
          ]);
        } else {
          setTabs([
            {
              title: 'Inspection confirmation',
              type: CommentType.INSPECTION,
              imageDescription: 'Warehouse’s  attachments',
              commentDescription: 'Comment from Warehouse :',
              imageUpload: true
            },
            {
              title: 'Request modify',
              description: 'Reasons for modification from Warehouse :',
              type: CommentType.REQUEST_MODIFY,
              options: []
            },
            {
              title: 'Request delete',
              description: 'Reasons for modification from Warehouse :',
              type: CommentType.REQUEST_DELETE,
              options: []
            }
          ]);
        }
    } else {
      setTabs([]);
    }

    if (commentList?.data) {
      const requestChangeIsApproved = commentList.data.find(
        (c: Comment) =>
          c.side === CommentSide.SELLER &&
          c.type === CommentType.REQUEST_MODIFY &&
          c.status === CommentStatus.APPROVE
      );
      if (requestChangeIsApproved) {
        setTabs([]);
      }
    }
  }, [detailData, commentList]);

  const onSendComment = async (body: CreateComment, id?: number) => {
    if (body.files && body.files.length) {
      const files = body.files;
      const fileResult = await commentService.commentUpload({
        attachments: files
      });
      body.attachmentIds = (fileResult?.data?.attachments ?? [])
        .map((f: any) => f.id)
        .join(',');
    }

    if (id) {
      await commentService.updateComment(id, body);
    } else {
      await commentService.sendComment(body);
    }
    await getCommentList();
  };

  const getCommentList = async (showLoading?: Boolean) => {
    if (showLoading) {
    }
    const comments = await commentService.getComments({
      group: CommentGroup.RETURN_DETAIL,
      itemId: parseInt(id)
    });
    setCommentList(comments);
    if (showLoading) {
    }
  };

  const removeItem = async () => {
    await returnDisposalService.deleteReturn(id);
    window.location.href = '/admin/returnDelivery';
  };

  useEffect(() => {
    getCommentList();
  }, []);

  useEffect(() => {
    handleReturnDisposalDetail(id);
  }, []);

  useEffect(() => {
    getCommentList();
  }, [canEdit]);

  useEffect(() => {
    if (commentList?.data.length) {
      const lastComment = commentList.data.slice(-1);
      if (lastComment[0].group === "RETURN_DETAIL" &&
        lastComment[0].type === "REQUEST_MODIFY" &&
        lastComment[0].extraData === "1" &&
        lastComment[0].status === "APPROVE") {
        handleReturnDisposalDetail(id);
        setShowReturnProcess(true);
      }
    }
  }, [commentList]);
  return (
    <>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div
        style={{
          background: 'white',
          padding: '50px 30px',
          margin: '40px 20px'
        }}
      >
        <ReturnOrderPage
          // canEdit={canEdit}
          canEdit={canEdit}
          doneEdit={() => setCanEdit(false)}
          commentId={commentAllId}
          showInspectionStatus={true}
          showProcessType={true}
        />
        {!canEdit && (
          <CommentTabsComponent
            onSend={onSendComment}
            tabs={tabs}
            commentList={commentList!}
            removeTitle="반품 신청 내용을 삭제 하시겠습니까?"
            refectComments={getCommentList}
            itemId={parseInt(id)}
            removeItem={removeItem}
            commentGroup={CommentGroup.RETURN_DETAIL}
            updateItem={(commentId: number) => {
              setCommentAllId(commentId);
              setCanEdit(true);
            }}
            inspectionLabel="Inspection confirmation"
          />
        )}
        {
          showReturnProcess &&
          <ProgressReturnForm
            detailData={{
              ...detailData?.data,
              deliveryStatus: detailData?.data?.returnStatus
            }}
          />
        }
        {
          showReturnProcess &&
          <div className="orderForm">
            <RecipientReturnForm detailData={detailData?.data} />
          </div>
        }
      </div>
    </>
  );
}

export default ReturnDeliveryDetail;
